import { Discount, useDiscountViewData } from "modules/discount"
import { Psychologist } from "utils/interfaces"
import { getLowestServicePrice } from "utils/helpers/psychologistUtil"

export function PsychologistDiscountBadge({ psy }: { psy: Psychologist }) {
    const { hasDiscount } = useDiscountViewData(psy, getLowestServicePrice(psy.offered_services))

    if (hasDiscount && psy.discount) {
        return <div className="discount-badge">скидка {new Discount(psy.discount).toString()}</div>
    }

    return null
}
